import type { IObjectiveAdditionalServices } from './ObjectiveAdditionalServices.interface';

export default class ObjectiveAdditionalServices implements IObjectiveAdditionalServices {
  insuranceAndAssetProtection: boolean;
  investmentSuperannuationAndFinancialPlanning: boolean;
  propertyBuyingAdvocacy: boolean;
  propertyInvestment: boolean;
  carBuyingAdvocacyOrFinance: boolean;
  conveyancing: boolean;
  estatePlanning: boolean;
  healthCover: boolean;

  static build = (data: IObjectiveAdditionalServices) => new ObjectiveAdditionalServices(data);
  static blank = () => new ObjectiveAdditionalServices();

  /**
   * Constructor
   * @param {IObjectiveAdditionalServices} data
   */
  constructor(data?: IObjectiveAdditionalServices) {
    this.insuranceAndAssetProtection = data?.insuranceAndAssetProtection === true;
    this.investmentSuperannuationAndFinancialPlanning =
      data?.investmentSuperannuationAndFinancialPlanning === true;
    this.propertyBuyingAdvocacy = data?.propertyBuyingAdvocacy === true;
    this.propertyInvestment = data?.propertyInvestment === true;
    this.carBuyingAdvocacyOrFinance = data?.carBuyingAdvocacyOrFinance === true;
    this.conveyancing = data?.conveyancing === true;
    this.estatePlanning = data?.estatePlanning === true;
    // TODO: data?.other is legacy data structure
    this.healthCover = data?.other === true || data?.healthCover === true;
  }
}
